import axios from 'axios'
import type { JobSubmitDescriptionAction } from '../../../state/actions/job/job'
import { getApiUrl, PERFORMANCE_BASED_JOB_API_URL } from '../../util/api/api'

const submitJobDescription = (payload: JobSubmitDescriptionAction['payload']) =>
  axios.post<void>(
    getApiUrl(`${PERFORMANCE_BASED_JOB_API_URL}/description/${payload.jobId}`),
    payload.data,
    {
      withCredentials: true,
    },
  )

export default submitJobDescription
